"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This implements MessageHandler interface
 * @param message
 * @param value
 */
function default_1(message, value) {
    value.event = 'RBRU-SITE';
    value.eventVendor = 'Site-Team';
    value.eventCategory = message.eventCategory;
    value.eventAction = message.eventAction;
    value.eventContent = message.eventContent;
    value.eventLabel = message.eventLabel;
    value.eventContext = message.eventContext;
    value.eventContextMessage = message.eventContextMessage;
    value.eventFormVersion = message.eventFormVersion;
    value.eventProduct = message.eventProduct;
    value.eventError = message.eventError;
    value.eventSuccess = message.eventSuccess;
    value.eventSection = message.eventSection;
    value.eventSubSection = message.eventSubSection;
    value.eventPositionSubSection = message.eventPositionSubSection;
    value.eventPositionElement = message.eventPositionElement;
    value.eventData = message.eventData;
    return value;
}
exports.default = default_1;
;
